import Modal from './Modal';
import Button from './Button';

export default function ConfirmationModal({
  setShowModal,
  isPending = null,
  handler,
  title = null,
  desc,
  btnText,
  variant = 'error',
  subDesc = null,
  showInput = false,
  inputValue = '',
  onInputChange = null,
  inputPlaceholder = '',
}) {
  return (
    <Modal className="gap-9 max-sm:gap-5 p-7" width="500" height="460" onOpenChange={setShowModal} title={title}>
      <div className="flex flex-col items-center justify-center gap-10 max-sm:gap-6 text-center w-full h-full">
        <img src={`/svg/${variant}.svg`} alt={variant} className="w-44 h-44 max-sm:w-32 max-sm:h-32" />
        <div className="flex flex-col items-center justify-center w-full gap-4">
          <p className="text-xl max-sm:text-sm text-text-hard font-medium text-center dark:text-white">{desc}</p>
          {subDesc && <p className="text-base max-sm:text-xs text-text-hard text-center">{subDesc}</p>}
          {showInput && (
            <div className="w-full">
              <textarea
                value={inputValue}
                onChange={onInputChange}
                placeholder={inputPlaceholder}
                className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="3"
              />
            </div>
          )}
        </div>
        <div className="flex items-center justify-center gap-6 max-sm:gap-4 w-full">
          <Button
            // endIcon={variant == 'error' ? 'trash' : null}
            isLoading={isPending}
            height="h-12"
            width="w-full"
            variant={variant == 'success' ? 'primary' : variant}
            handler={handler}
            font="base"
          >
            {btnText}
          </Button>
          <Button height="h-12" width="w-full" variant="text" handler={() => setShowModal(false)} font="base">
            انصراف
          </Button>
        </div>
      </div>
    </Modal>
  );
}
